import { ParseError } from "papaparse";
import { Pagination } from "../index";

export type RawRequestBody = {
  [key: string]: any;
  email: string;
  company: {
    name: string;
    rut: string;
  };
  variables: { value: string; name: string }[];
  templates: string[];
};
/**
 * Raw JSON object for Requests used in Vuex store
 */
export type RawRequest = {
  id: string;
  body: RawRequestBody;
  edited: boolean;
  errors?: ParseError[];
};

export const BATCH_STATES = [
  { value: "created", label: "Creada", color: "grey" },
  { value: "queueing", label: "En cola", color: "accent" },
  { value: "pending", label: "Pendiente", color: "orange" },
  { value: "confirmed", label: "Confirmada", color: "primary" },
  { value: "completed", label: "Finalizada", color: "success" }
];

/**
 * Raw JSON object for Batches used in Vuex store
 */
export type RawBatch = {
  id: string;
  name: string;
  description: string;
  state: "created" | "queueing" | "pending" | "confirmed" | "completed" | "";
  raw_requests: RawRequest[];
  source?: File;
};

export type BatchResource = {
  id: string;
  type: "batch";
  attributes: {
    id: string;
    name: string;
    state: number;
    description: string;
    drive_id: string;
    raw_requests: RawRequest[];
  };
  meta: {
    created_at: string;
    updated_at: string;
    requests_parsed: number;
    requests_created: number;
    state: string;
  };
};

export type BatchIndexResponse = {
  batches: {
    data: BatchResource[];
  };
  pagination: Pagination & { totalItems: number };
};

export type BatchShowResponse = {
  data: BatchResource;
};
/**
 * State for the batch module
 */
export interface BatchState {
  batches: { [key: string]: BatchResource }; // id indexed batch set
  batchesList: string[]; // Array of sorted batches ID
  selected: RawBatch; // Selected batch to edit/create
}
